import React, { useState } from "react";

import { cn } from "lib/utils";
import HealthCard from "./HealthCard.js";
import DetailsView from "../detailsView";
import MetricCard from "./MetricCard.js";

const queryNames = [
    "event_response_times",
    "slow_clients",
    "slow_clients_analysis",
    "http_status_codes",
    "bytes_served",
    "request_rate",
    "frequent_segment_requests",
    
    // hevc specific queries
    "hevc_event_response_times",
    "hevc_http_status_codes",
    "hevc_bytes_served",
    "hevc_request_rate",
    "hevc_frequent_segment_requests",
];
const metricNames = [
    { cardTitle: "CPU Utilization (%)", metricName: "CPUUtilization" },
    { cardTitle: "Network Out (KB)", metricName: "NetworkOut" },
    { cardTitle: "Disk Write (KB)", metricName: "DiskWriteBytes" },
];

// Static maps so Tailwind's JIT keeps the grid classes; chart height is inline style.
// (Interpolated class names like `md:grid-cols-${n}` would be purged at build time.)
const GRID_COLS_MAP = {
    1: "md:grid-cols-1",
    2: "md:grid-cols-2",
    3: "md:grid-cols-3",
    4: "md:grid-cols-4",
};
const CHART_HEIGHT_MAP = { 1: 360, 2: 220, 3: 150, 4: 150 };

function Health({ eventId, environment, startTime, endTime, theme, columns }) {
    const [detailsState, setDetailsState] = useState({
        open: false,
        kind: null,
        title: "",
        data: null,
        csv: null,
    });

    const chartHeight = CHART_HEIGHT_MAP[columns];

    function openDetails(kind, title, data, csv = null) {
        setDetailsState({ open: true, kind, title, data, csv });
    }

    let homeBodyContent;
    if (eventId && environment) {
        homeBodyContent = (
            <>
                <div className={cn("grid grid-cols-1 gap-4", GRID_COLS_MAP[columns])}>
                    {queryNames.map((queryName, index) => (
                        <HealthCard
                            key={index}
                            queryName={queryName}
                            eventId={eventId}
                            environment={environment}
                            startTime={startTime}
                            endTime={endTime}
                            chartHeight={chartHeight}
                            openDetails={openDetails}
                        />
                    ))}

                    {metricNames.map((metric, index) => (
                        <MetricCard
                            key={index}
                            CardTitle={metric.cardTitle}
                            metricName={metric.metricName}
                            eventId={eventId}
                            environment={environment}
                            startTime={startTime}
                            endTime={endTime}
                            chartHeight={chartHeight}
                            openDetails={openDetails}
                        />
                    ))}
                </div>
            </>
        );
    }

    return (
        <div>
            {homeBodyContent}

            <DetailsView
                open={detailsState.open}
                onOpenChange={(open) => setDetailsState((prev) => ({ ...prev, open }))}
                details={detailsState}
                startTime={startTime}
                endTime={endTime}
                theme={theme}
            />
        </div>
    );
}

export default Health;
